/**
 * Future public Clarity Group website hostname (www.claritygroup.com.sg).
 *
 * Phase One serves the website inside the Portal as a Sandbox module at
 * /sandbox/clarity-website. When DNS for www.claritygroup.com.sg points at
 * this app, the same pages mount at "/" via ClarityWebsiteDomainRouter —
 * mirroring the knowledge.claritygroup.com.sg and one.claritygroup.com.sg
 * hostname-routing pattern. No production route changes are required.
 */
export const CLARITY_WEBSITE_HOSTNAMES = [
  "www.claritygroup.com.sg",
  "claritygroup.com.sg",
] as const;

/** Sandbox mount point while the website lives inside the Portal. */
export const CLARITY_WEBSITE_SANDBOX_BASE_PATH = "/sandbox/clarity-website";

export function normalizeHostname(hostname: string): string {
  return hostname.trim().toLowerCase().split(":")[0] ?? "";
}

export function isClarityWebsiteHostname(hostname: string): boolean {
  const normalized = normalizeHostname(hostname);
  return (CLARITY_WEBSITE_HOSTNAMES as readonly string[]).includes(normalized);
}

/**
 * Base path for all website routes in the current serving context.
 * "" on the public hostname; the sandbox prefix inside the Portal.
 */
export function getClarityWebsiteBasePath(hostname: string): string {
  return isClarityWebsiteHostname(hostname) ? "" : CLARITY_WEBSITE_SANDBOX_BASE_PATH;
}
